// Presentation of the held AC provenance; mitigation is already decided by the compiler.
import type { CachedCaster } from './types';
import { renderSourceLineBlock } from './source-line-block';
import { setActiveInfoPanel, paintActiveInfoPanel } from './active-panel';

function renderDamageMitigationPanel(caster: CachedCaster): string {
    const part = caster.computed?.creature?.ac?.mitigation;
    // Same cluster-first read as the summary, including scalar and explicit-zero totals.
    const raw = part !== undefined && part !== null
        ? (typeof part === 'object' ? part.total : part)
        : ftLayerValue(caster, 'damage_mitigation');
    const value = Number(Array.isArray(raw) ? raw[0] : raw);
    const total = Number.isFinite(value) ? value : 0;
    const sources = part && typeof part === 'object' && Array.isArray(part.sources)
        ? part.sources.filter(row => row !== null && typeof row === 'object' && !Array.isArray(row)) : [];
    return `<table class="table border">
        <thead><tr><th scope="col" colspan="2" class="table-dark align-middle">${iconMap('damage_mitigation')} Damage Mitigation</th></tr></thead>
        <tbody><tr><th scope="row" class="align-middle">Current</th>
            <td class="text-end"><h3 class="mb-0"><span class="badge bg-danger">${total > 0 ? '+' : ''}${total}</span></h3></td>
        </tr></tbody>
    </table>
    <div class="text-start border rounded p-3 mb-3 small">Damage Mitigation reduces the amount of damage taken from each instance of incoming damage by this flat amount (applied after resistances).</div>
    <div class="mb-2"><div class="small text-muted mb-1">Sources</div>
        ${renderSourceLineBlock(sources, 'damage_mitigation', total, 'bg-secondary', caster)}
    </div>`;
}

/** Warm inspection never fetches or recompiles. Cache updates patch only this active panel. */
export async function renderDamageMitigationInfoPanel(casterId: string, targetId = 'div_refresh_side_info'): Promise<void> {
    const target = document.getElementById(targetId);
    if (!target) return;
    const caster = window.FateTide?.casterCache?.get(casterId) as CachedCaster | undefined;
    if (!caster) {
        target.textContent = 'Creature data is not available.';
        return;
    }
    setActiveInfoPanel(casterId, targetId, renderDamageMitigationPanel);
    paintActiveInfoPanel(caster);
}
